import React, { Fragment, useState, useEffect } from "react";
import { Icon } from "@cdk-uip/react-icon";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { pdf } from "@react-pdf/renderer";
import ToolkitProvider, {
  Search,
  CSVExport
} from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import api from "../../api/sezForm.resource";
import {
  sortByDate,
  getFormattedDate,
  getRelationshipDescription,
  getSerialIDNo
} from "../../util/helpers";
import { SEZPDFTemplate } from "./SEZPDFTemplate";

export const SEZCandidateList = ({ history }) => {
  const [sezEmployeeList, setSezEmployeeList] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getSezEmployeeList();
  }, []);
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const columns = [
    {
      text: "S.No.",
      hidden: true,
      csvFormatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      dataField: "employeeId",
      text: "Employee Id",
      headerStyle: { width: "15%" },
      sort: "true",
      csvExport: false
    },
    {
      dataField: "employeeName",
      text: "Name",
      headerStyle: { width: "20%" },
      sort: "true",
      csvText: "Employee's Name"
    },
    {
      dataField: "designation",
      text: "Designation",
      headerStyle: { width: "20%" },
      sort: "true"
    },
    {
      text: "Serial / ID No",
      hidden: true,
      csvFormatter: (cell, row, rowIndex) => getSerialIDNo(row.employeeId)
    },
    {
      dataField: "dateOfBirth",
      text: "Date of Birth",
      headerStyle: { width: "15%" },
      csvExport: false
    },
    {
      dataField: "dateOfJoining",
      text: "Date of Joining",
      headerStyle: { width: "15%" },
      sort: "true",
      sortFunc: (a, b, order) => sortByDate(a, b, order),
      csvExport: false
    },
    {
      text: "Submission Date",
      headerStyle: { width: "15%" },
      hidden: true,
      csvFormatter: (cell, row, rowIndex) => getFormattedDate(row.submitedDate)
    },
    {
      dataField: "",
      text: "Actions",
      headerStyle: { width: "10%" },
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <Fragment>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderTooltip("View Pdf")}
            >
              <Icon
                className="on-hover"
                onClick={() => handleOnClickViewEmployee(row)}
              >
                visibility
              </Icon>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderTooltip("Download Pdf")}
            >
              <Icon className="on-hover" onClick={() => getPDF(row)}>
                file_download
              </Icon>
            </OverlayTrigger>
          </Fragment>
        );
      }
    }
  ];

  const sizePerPageList = [
    {
      text: "5",
      value: 5
    },
    {
      text: "10",
      value: 10
    },
    {
      text: "20",
      value: 20
    },
    {
      text: "50",
      value: 50
    },
    {
      text: "100",
      value: 100
    }
  ];
  const defaultSorted = [
    {
      dataField: "employeeId",
      order: "asc"
    }
  ];

  const handleOnClickViewEmployee = employee => {
    history.push({
      pathname: "/SEZPDF",
      state: {
        employee
      }
    });
  };

  const generatePDFsandZIP = () => {
    const zip = new JSZip();
    const employeeData = getUserData();
    employeeData.forEach(employee =>
      zip.file(
        `${employee.employeeId}_${employee.employeeName}.pdf`,
        pdf(<SEZPDFTemplate employee={employee} />).toBlob()
      )
    );

    return zip.generateAsync({ type: "blob" }).then(blob => {
      saveAs(blob, "SEZCards.zip");
    });
  };
  const getPDF = async employee => {
    const blob = await pdf(<SEZPDFTemplate employee={employee} />).toBlob();
    saveAs(blob, employee.employeeId);
  };
  const handleOnClickBulkDownload = async () => {
    setShowSpinner(true);
    await generatePDFsandZIP();
    setShowSpinner(false);
  };
  const getSezEmployeeList = async () => {
    setLoading(true);
    const data = await api.getSezEmployeeList();
    setLoading(false);
    setSezEmployeeList(data);
  };
  const getUserData = () => {
    return sezEmployeeList && sezEmployeeList.length
      ? sezEmployeeList.map(row => ({
          ...row,
          dateOfBirth: getFormattedDate(row.dateOfBirth),
          dateOfJoining: getFormattedDate(row.dateOfJoining),
          relationShipWithMe: getRelationshipDescription(row.relationShipWithMe)
        }))
      : [];
  };

  const renderTooltip = message => {
    return <Tooltip id={message}>{message}</Tooltip>;
  };
  return (
    <div className="mt-3 mr-3">
      <div className="text-left">
        <h5> SEZ Candidates Information</h5>
      </div>
      <ToolkitProvider
        keyField="id"
        data={getUserData()}
        columns={columns}
        search
        exportCSV={{ fileName: "Candidates.csv" }}
      >
        {props => (
          <Fragment>
            <div className="candidates-search-bar">
              <Button
                onClick={handleOnClickBulkDownload}
                variant="outline-secondary"
                className="mr-3 mb-2 "
                disabled={
                  (sezEmployeeList && !sezEmployeeList.length) || showSpinner
                }
              >
                {showSpinner ? "DOWNLOADING..." : "DOWNLOAD SEZ FORMs"}
              </Button>
              <SearchBar {...props.searchProps} />
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 200 }}
                overlay={renderTooltip("Export to CSV")}
              >
                <ExportCSVButton {...props.csvProps}>
                  <Icon>file_download</Icon>
                </ExportCSVButton>
              </OverlayTrigger>
            </div>
            <BootstrapTable
              {...props.baseProps}
              striped
              condensed
              bootstrap4
              pagination={paginationFactory({
                sizePerPage: 20,
                sizePerPageList: sizePerPageList
              })}
              defaultSorted={defaultSorted}
              noDataIndication={
                loading ? "Loading....." : "No employees are available."
              }
            />
          </Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default SEZCandidateList;
